import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7da12145"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "form-box"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "btn-view"
};
import { clearData } from '@/utils/tools';
const __default__ = {
  name: 'SearchInput'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    isShowBtns: {
      type: Boolean,
      default: true
    },
    isInline: {
      type: Boolean,
      default: true
    },
    // 表单绑定数据
    formData: {
      type: Object,
      default: () => ({})
    },
    // 表单校验对象
    formRules: {
      type: Object,
      default: () => ({})
    },
    // labe默认长度
    labelWidth: {
      type: String,
      default: '100px' // 120px

    },
    // 表单列表
    formList: {
      type: Array,
      default: () => [] // default: [],

    },
    size: {
      type: Object,
      default: {
        sm: 24,
        md: {},
        lg: 12,
        xl: 12,
        xs: 24
      }
    },
    gutter: {
      type: Number,
      default: 60
    }
  },
  emits: ['search', 'reset'],

  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const mForm = ref();
    expose({
      mForm
    });

    const showController = item => {
      const {
        controller
      } = item;
      return controller ? controller(props.formData[item.prop], props.formData, item) : true;
    };

    const focusMethods = () => {
      console.log('focus');
    }; // 抛出搜索按钮事件


    const search = () => {
      emit('search', props.formData);
    }; // 抛出重置按钮事件


    const reset = () => {
      clearData(props.formData);
      emit('reset');
    };

    return (_ctx, _cache) => {
      const _component_WidgetItem = _resolveComponent("WidgetItem");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        model: __props.formData,
        "label-width": __props.labelWidth,
        rules: __props.formRules,
        ref_key: "mForm",
        ref: mForm,
        inline: __props.isInline
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: __props.gutter
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formList, (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, null, [showController(item) ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              sm: __props.size.sm,
              md: __props.size.md,
              lg: __props.size.lg,
              xl: __props.size.xl,
              xs: __props.size.xs,
              span: item.span || 24 / 3,
              style: _normalizeStyle({
                minWidth: item.labelWidth
              })
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                class: _normalizeClass(item.class ? item.class : ''),
                label: _ctx.$t(item.label),
                prop: item.prop,
                "label-width": item.labelWidth ? item.labelWidth : '',
                rules: item.rules,
                onFocus: focusMethods,
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_WidgetItem, {
                  "widget-config": item,
                  "widget-data": __props.formData
                }, null, 8, ["widget-config", "widget-data"])]),
                _: 2
              }, 1032, ["class", "label", "prop", "label-width", "rules"])]),
              _: 2
            }, 1032, ["sm", "md", "lg", "xl", "xs", "span", "style"])) : _createCommentVNode("", true)], 64);
          }), 256)), __props.isShowBtns ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            sm: __props.size.sm,
            md: __props.size.md,
            lg: __props.size.lg,
            xl: __props.size.xl,
            xs: __props.size.xs,
            style: {
              "margin-left": "auto"
            }
          }, {
            default: _withCtx(() => [_renderSlot(_ctx.$slots, "customBtn"), __props.isShowBtns ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "searchItem", {}, () => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
              class: "search-btn",
              onClick: search
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('查询')), 1)]),
              _: 1
            }), _createVNode(_component_el_button, {
              class: "reset-btn cms-op-btn-non-focus",
              onClick: reset
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('重置')), 1)]),
              _: 1
            })])])])) : _createCommentVNode("", true)]),
            _: 3
          }, 8, ["sm", "md", "lg", "xl", "xs"])) : _createCommentVNode("", true)]),
          _: 3
        }, 8, ["gutter"])]),
        _: 3
      }, 8, ["model", "label-width", "rules", "inline"])]);
    };
  }

});